import ApplicationInformationCard from './ApplicationInformationCard.component';

export default ApplicationInformationCard;